"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isYesOrTrue = void 0;
var isYesOrTrue = exports.isYesOrTrue = function isYesOrTrue(configProp) {
  return configProp === true || configProp === "Yes" || configProp === "yes" || configProp === 1 || configProp === "True" || configProp === "true";
};
//# sourceMappingURL=utilities.js.map